import { IntlProvider } from 'app/shared/providers/intl-provider';
import { AppRouter } from 'app/components/router';
import { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ApiProvider } from 'app/shared/contexts/api';
import { BuildingProvider } from 'app/shared/contexts/building';
import { UserProvider } from 'app/shared/contexts/user';
import { FeatureFlagsProvider } from 'app/shared/contexts/feature-flags';
import { ThemeProvider } from 'app/shared/contexts/theme';
import { MiniappSdkProvider } from 'app/shared/contexts/miniapp-sdk';
import { QueryClientProvider } from 'app/shared/providers/query-client-provider';
import { ErrorsProvider } from 'app/shared/contexts/errors';
import { TokenRefreshManager } from 'app/components/token-refresh-manager';
import { HostInfoProvider } from 'app/shared/contexts/host-info';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { ContentProvider } from 'app/shared/contexts/content';
import '../index.css';

// Add FontAwesome icons to the library
library.add(fab as never, fal as never, far as never, fas as never);

export const App: FC = () => (
  <ErrorsProvider>
    <QueryClientProvider>
      <BrowserRouter>
        <ApiProvider>
          <MiniappSdkProvider>
            <TokenRefreshManager />
            <HostInfoProvider>
              <UserProvider>
                <IntlProvider>
                  <BuildingProvider>
                    <ThemeProvider>
                      <FeatureFlagsProvider>
                        <ContentProvider>
                          <AppRouter />
                        </ContentProvider>
                      </FeatureFlagsProvider>
                    </ThemeProvider>
                  </BuildingProvider>
                </IntlProvider>
              </UserProvider>
            </HostInfoProvider>
          </MiniappSdkProvider>
        </ApiProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </ErrorsProvider>
);
